module.exports = __webpack_public_path__ + "img/mh1.570d53ab.jpg";